/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The UpdateCustomerRequest model module.
* @module model/UpdateCustomerRequest
* @version 2020-12-7
*/
export default class UpdateCustomerRequest {
    /**
    * Constructs a new <code>UpdateCustomerRequest</code>.
    * 顧客更新リクエスト
    * @alias module:model/UpdateCustomerRequest
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>UpdateCustomerRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/UpdateCustomerRequest} obj Optional instance to populate.
    * @return {module:model/UpdateCustomerRequest} The populated <code>UpdateCustomerRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UpdateCustomerRequest();
                        
            
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('groupId')) {
                obj['groupId'] = ApiClient.convertToType(data['groupId'], 'Number');
            }
            if (data.hasOwnProperty('deliveryGroupId')) {
                obj['deliveryGroupId'] = ApiClient.convertToType(data['deliveryGroupId'], 'Number');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], 'String');
            }
            if (data.hasOwnProperty('tel')) {
                obj['tel'] = ApiClient.convertToType(data['tel'], 'String');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
        }
        return obj;
    }

    /**
    * 名称
    * @member {String} name
    */
    'name' = undefined;
    /**
    * グループID
    * @member {Number} groupId
    */
    'groupId' = undefined;
    /**
    * 配送グループID
    * @member {Number} deliveryGroupId
    */
    'deliveryGroupId' = undefined;
    /**
    * 住所
    * @member {String} address
    */
    'address' = undefined;
    /**
    * 電話番号
    * @member {String} tel
    */
    'tel' = undefined;
    /**
    * 備考
    * @member {String} remarks
    */
    'remarks' = undefined;




}
